export function getCurrencyByMode(amount, mode) {
  if (mode == "PROD_H_THAI") {
    return `฿${amount}`;
  } else if (mode == "PROD_H_THAI_INDO") {
    return `Rp${amount}`;
  } else {
    return `฿${amount}`;
  }
}

export default getCurrencyByMode;
